import { FETCH_SUBSCRIPTION_PLANS } from '../actions/types';

const initialState = null;

function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS:
      return action.payload;
    default:
      return state;
  }
}
export default reducer;
